// extracted by mini-css-extract-plugin
export default {"statistic":"ContentfulStatistics-module__statistic--jA5Kp"};